import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { VtResponse } from './vt.service';

@Injectable({ providedIn: 'root' })
export class VtsService {
    constructor(private dataTask: DataTaskService) {}

    public getSetting(): Promise<VtsSetting[]> { return this.dataTask.Post(3796); }
    public importVtFromDisc(): Promise<VtResponse[]> { return this.dataTask.Post(3798, {}); }
}

export interface VtsSetting { vt_keyno: string; dev: string; }
